import React, { useState } from 'react';
import axios from 'axios';
import './MandiBhav.css';

const MandiBhav = () => {
  const [commodity, setCommodity] = useState('');
  const [state, setState] = useState('');
  const [district, setDistrict] = useState('');
  const [marketData, setMarketData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const fetchMarketPrices = async () => {
    if (!commodity && !state && !district) {
      setError('Please enter at least one search criteria');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let apiUrl = `https://api.data.gov.in/resource/9ef84268-d588-465a-a308-a864a43d0070?api-key=579b464db66ec23bdd000001b94a35c0130d46a15f058383f452e7c4&format=json&limit=1000`;

      if (state) {
        apiUrl += `&filters[state]=${encodeURIComponent(state)}`;
      }
      if (district) {
        apiUrl += `&filters[district]=${encodeURIComponent(district)}`;
      }
      if (commodity) {
        apiUrl += `&filters[commodity]=${encodeURIComponent(commodity)}`;
      }

      const response = await axios.get(apiUrl);
      const data = response.data.records.map((record, index) => ({
        S_No: index + 1,
        City: record.market,
        Commodity: record.commodity,
        Min_Prize: record.min_price,
        Max_Prize: record.max_price,
        Market_Price: record.modal_price,
        State: record.state,
        District: record.district,
      }));

      setMarketData(data);
      setFilteredData(data);
    } catch (error) {
      console.error('Error fetching market prices:', error);
      setError('Failed to fetch market data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      fetchMarketPrices();
    }
  };

  return (
    <div className="mandi-bhav-container">
      <div className="mandi-bhav-header">
        <div className="header-content">
          <h1 className="main-title">Mandi Bhav</h1>
          <p className="subtitle">Get real-time market prices across India</p>
        </div>
      </div>

      <div className="search-section">
        <div className="search-container">
          <div className="input-group">
            <div className="input-wrapper">
              <input
                type="text"
                value={commodity}
                onChange={(e) => setCommodity(toTitleCase(e.target.value))}
                onKeyPress={handleKeyPress}
                placeholder="Commodity"
                className="search-input"
              />
              <div className="input-icon">🌾</div>
            </div>
          </div>

          <div className="input-group">
            <div className="input-wrapper">
              <input
                type="text"
                value={state}
                onChange={(e) => setState(toTitleCase(e.target.value))}
                onKeyPress={handleKeyPress}
                placeholder="State"
                className="search-input"
              />
              <div className="input-icon">🏛️</div>
            </div>
          </div>

          <div className="input-group">
            <div className="input-wrapper">
              <input
                type="text"
                value={district}
                onChange={(e) => setDistrict(toTitleCase(e.target.value))}
                onKeyPress={handleKeyPress}
                placeholder="District"
                className="search-input"
              />
              <div className="input-icon">🏘️</div>
            </div>
          </div>

          <button
            onClick={fetchMarketPrices}
            disabled={loading}
            className={`search-button ${loading ? 'loading' : ''}`}
          >
            {loading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
              </div>
            ) : (
              'Search'
            )}
          </button>
        </div>

        {error && (
          <div className="error-message">
            <span>⚠️</span>
            <span>{error}</span>
          </div>
        )}
      </div>

      <div className="results-section">
        {filteredData.length > 0 ? (
          <>
            <div className="results-header">
              <h2 className="results-title">Market Price Results</h2>
              <div className="results-count">
                Found {filteredData.length} price entries
              </div>
            </div>
            
            <div className="price-list-container">
              <div className="price-list">
                <div className="list-header">
                  <div className="header-item">#</div>
                  <div className="header-item">Market</div>
                  <div className="header-item">Commodity</div>
                  <div className="header-item">Price</div>
                </div>
                
                {filteredData.map((item, index) => (
                  <div
                    key={index}
                    className="list-item"
                    style={{ animationDelay: `${index * 0.05}s` }}
                  >
                    <div className="item-cell">{item.S_No}</div>
                    <div className="item-cell">{item.City}</div>
                    <div className="item-cell">{item.Commodity}</div>
                    <div className="item-cell market-price">₹{item.Market_Price}/q</div>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <div className="no-data">
            <div className="no-data-icon">📊</div>
            <h3 className="no-data-title">No Data Found</h3>
            <p className="no-data-text">
              Try adjusting your search criteria or check if the data is available for your selected parameters.
            </p>
          </div>
        )}
      </div>

      <div className="info-section">
        <div className="info-card">
          <h3>💡 Tips for Better Results</h3>
          <ul>
            <li>Enter specific commodity names like "Rice", "Wheat", "Tomato"</li>
            <li>Use exact state and district names</li>
            <li>Leave fields empty to get broader results</li>
            <li>Data is updated daily from government sources</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MandiBhav;
